import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

export const supportedLanguageCodes = [
  "en",
  "es",
  "fr",
  "hi",
  "mr",
  "gu",
  "bn",
  "kn",
  "ta",
  "ml",
] as const;

export const isSupportedLanguageCode = (
  value: unknown
): value is (typeof supportedLanguageCodes)[number] =>
  typeof value === "string" &&
  (supportedLanguageCodes as readonly string[]).includes(value);

void i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: "en",
    ns: ["common"],
    defaultNS: "common",
    debug: process.env.NODE_ENV === "development",
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
  });

export default i18n;
